import { connect } from 'react-redux'
import { ContentItem } from 'interfaces'
import CardList from 'components/CardList'
import AnyCard from 'components/Card'
import { PPDialog } from 'components/PPDialog'
import StoreState, { StoreDispatch } from 'store/state'
import { closeContentPopup, contentPopupActiveSelector, contentPopupItemsSelector } from 'services/contentPopup'

import styles from './ContentPopup.pcss'

interface ContentPopupProps {
  open: boolean
  items: ContentItem[]
  closePopup(): void
}

export function ContentPopup(props: ContentPopupProps) {
  return (
    <PPDialog open={props.open} onClose={props.closePopup} title="Content" className={styles.dialog}>
      <div className={styles.body}>
        <CardList containerClassName={styles.list}>
          {
            props.items
              .map((item, index) => (
                <AnyCard
                  key={`${item.id}-${index}`}
                  content={item as ContentItem}
                  children={item as ContentItem}
                />
              ))
          }
        </CardList>
      </div>
    </PPDialog>
  )
}

function mapStateToProps(state: StoreState) {
  const open = contentPopupActiveSelector(state)
  const items = contentPopupItemsSelector(state)

  return { open, items }
}

function mapDispatchToProps(dispatch: StoreDispatch) {
  return {
    closePopup: () => { dispatch(closeContentPopup()) }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ContentPopup)
